var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGasto({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.917 9.651v5.232h-3.685c-.76 0-1.377-.6-1.378-1.34v-2.55c.001-.741.618-1.341 1.378-1.342h3.685zm-1.377 9.455H2.295c-.76 0-1.376-.6-1.377-1.341V5.169H17.54c.76 0 1.376.6 1.377 1.341v2.247h-3.685c-1.267.001-2.294 1.001-2.296 2.235v2.55c.002 1.234 1.029 2.234 2.296 2.235h3.685v1.988c0 .74-.617 1.34-1.377 1.34zM12.55.97c.422-.145.89-.082 1.255.17.365.25.582.659.582 1.094v2.04H2.972L12.55.97zm4.99 3.304h-2.235v-2.04c0-.726-.361-1.406-.97-1.825a2.348 2.348 0 00-2.092-.282L.253 4.264l.018.05A.447.447 0 000 4.723v13.043C.001 18.999 1.028 19.999 2.296 20H17.54c1.267-.001 2.294-1.001 2.295-2.235V6.51c-.001-1.234-1.028-2.234-2.295-2.235z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGasto);
export default __webpack_public_path__ + "static/media/icon_gasto.b7154af94251afe5c636feb95b8693e1.svg";
export { ForwardRef as ReactComponent };